import React from 'react';
import styled from 'styled-components';
import { useNavigate } from 'react-router-dom';
import { useLanguage } from '../../../contexts/LanguageContext';
import { FaArrowLeft, FaPhone, FaClock, FaGlobe } from 'react-icons/fa';

const Container = styled.div`
  padding: 1rem;
`;

const BackButton = styled.button`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  background: none;
  border: none;
  color: var(--text-primary);
  font-size: 16px;
  cursor: pointer;
  padding: 0.5rem 0;
  margin-bottom: 1rem;

  svg {
    font-size: 20px;
  }
`;

const Title = styled.h1`
  font-size: 24px;
  color: var(--text-primary);
  margin: 0 0 1.5rem 0;
`;

const Card = styled.div`
  background-color: var(--bg-secondary);
  border-radius: 10px;
  padding: 2rem;
  margin-bottom: 1.5rem;
`;

const PhoneNumber = styled.a`
  display: flex;
  align-items: center;
  gap: 1rem;
  color: var(--primary-color);
  font-size: 24px;
  font-weight: 500;
  text-decoration: none;
  margin-bottom: 1.5rem;

  &:hover {
    color: var(--primary-color-dark);
  }

  svg {
    font-size: 28px;
  }
`;

const InfoSection = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
  margin-bottom: 1rem;
  color: var(--text-secondary);

  svg {
    font-size: 20px;
  }
`;

const Description = styled.p`
  color: var(--text-secondary);
  line-height: 1.6;
  margin: 0 0 1.5rem 0;
`;

const Phone: React.FC = () => {
  const navigate = useNavigate();
  const { t } = useLanguage();

  return (
    <Container>
      <BackButton onClick={() => navigate('/profile/help')}>
        <FaArrowLeft />
        {t('common.back')}
      </BackButton>

      <Title>{t('help.phone.title')}</Title>

      <Card>
        <PhoneNumber href="tel:+33123456789">
          <FaPhone />
          +33 1 23 45 67 89
        </PhoneNumber>

        <Description>{t('help.phone.description')}</Description>

        <InfoSection>
          <FaClock />
          {t('help.phone.hours')}
        </InfoSection>

        <InfoSection>
          <FaGlobe />
          {t('help.phone.availability')}
        </InfoSection>
      </Card>
    </Container>
  );
};

export default Phone; 